export default "__VITE_ASSET__CyNSn4GZ__"